const isRestricted = (setup, attrs = {}) => {
	if (setup?.languages && Object.keys(setup.languages).length > 0) {
		const defaultLanguage = setup.languages?.default || Object.keys(setup.languages)?.[0] || {};
		const language = defaultLanguage.language === setup.language ? 'default' : setup.language;
		// Restrict content based on language
		if (attrs.selectedLanguages && Array.isArray(attrs.selectedLanguages) && attrs.selectedLanguages.indexOf(language) === -1) return true;
		if (attrs.restrictedLanguages && Array.isArray(attrs.restrictedLanguages) && attrs.restrictedLanguages.indexOf(language) !== -1) return true;
	}
	// Restrict content based on country
	if (attrs.selectedCountries && Array.isArray(attrs.selectedCountries) && attrs.selectedCountries.indexOf(setup.country) === -1) return true;
	if (attrs.restrictedCountries && Array.isArray(attrs.restrictedCountries) && attrs.restrictedCountries.indexOf(setup.country) !== -1) return true;
	// Restrict based on "device" desktop >= 900 mobile < 600
	if (attrs.desktop && !(setup.breakPoint === 'desktop' || setup.breakPoint === 'tablet')) return true;
	if (attrs.mobile && setup.breakPoint !== 'mobile') return true;

	return false;
};

const restrictedType = (setup, attrs = {}) => {
	if (setup?.languages && Object.keys(setup.languages).length > 0) {
		const defaultLanguage = setup.languages?.default || Object.keys(setup.languages)?.[0] || {};
		const language = defaultLanguage.language === setup.language ? 'default' : setup.language;
		// Restrict content based on language
		if (attrs.selectedLanguages && Array.isArray(attrs.selectedLanguages) && attrs.selectedLanguages.indexOf(language) !== -1) return 'language';
		if (attrs.restrictedLanguages && Array.isArray(attrs.restrictedLanguages) && attrs.restrictedLanguages.indexOf(language) === -1) return 'language';
	}
	// Restrict content based on country
	if (attrs.selectedCountries && Array.isArray(attrs.selectedCountries) && attrs.selectedCountries.indexOf(setup.country) !== -1) return 'country';
	if (attrs.restrictedCountries && Array.isArray(attrs.restrictedCountries) && attrs.restrictedCountries.indexOf(setup.country) === -1) return 'country';
	// Restrict based on "device" desktop >= 900 mobile < 600
	if (attrs.desktop && (setup.breakPoint === 'desktop' || setup.breakPoint === 'tablet')) return 'desktop';
	if (attrs.mobile && setup.breakPoint === 'mobile') return 'mobile';

	return '';
};

export { isRestricted, restrictedType };
